import htmlTemplate from './search-form.directive.html';

(function () {
	"use strict";

	angular.module("cardspotWeb.areas.fulfillment")
        .directive("emlSearchForm", configDirective);

	function configDirective() {
		return {
			restrict: "E",
			scope: {
				search: "=",
				onSearchClick: "=",
				dateFormat: "=",
				orderStatuses: "=",
				queueType: "="
			},
			controller: SearchFormController,
			controllerAs: "model",
			template: htmlTemplate
		};
	}

	SearchFormController.$inject = ["$scope", "$translate", "$rootScope"];

	function SearchFormController($scope, $translate, $rootScope) {
		var model = this;
		model.resetSearchForm = resetSearchForm;
		model.statusMultiSelectSettings = { 
			checkBoxes: true, 
			enableSearch: true, 
			showCheckAll: false, 
			showUncheckAll: false
		};

		$scope.beginDatePopup = {
			opened: false
		};

		$scope.openBeginDatePicker = function () {
			$scope.beginDatePopup.opened = true;
		};

		$scope.endDatePopup = {
			opened: false
		};

		$scope.openEndDatePicker = function () {
			$scope.beginDatePopup.opened = false;
			$scope.endDatePopup.opened = true;
		};

		$scope.beginFundedDatePopup = {
			opened: false
		};

		$scope.openBeginFundedDatePicker = function () {
			$scope.beginFundedDatePopup.opened = true;
		};

		$scope.endFundedDatePopup = {
			opened: false
		};

		$scope.openEndFundedDatePicker = function () {
			$scope.beginFundedDatePopup.opened = false;
			$scope.endFundedDatePopup.opened = true;
		};

		var QUEUE_TYPES = {
			CONSUMER: "consumer",
			CORPORATE: "corporate"
		};
		$scope.QUEUE_TYPES = QUEUE_TYPES;
		model.altDateInputFormats = $rootScope.altDateInputFormats;

		function resetSearchForm() {
			$scope.search.filterText = null;
			$scope.search.orderBeginDate = null;
			$scope.search.orderEndDate = null;
			$scope.search.fundedBeginDate = null;
			$scope.search.fundedEndDate = null;
			$scope.search.selectedOrderStatuses = [];
			$scope.searchForm.$setPristine();
			$scope.onSearchClick();
		}
	}
}());
